import { DeepReadonly, readonly, Ref } from 'vue'

import { useLoading } from '@/shared/composables/use-loading'

interface UseChatHistoryLoading {
  startLoading: () => void;
  stopLoading: () => void;
  loading: DeepReadonly<Ref<boolean>>;
}

const { loading, startLoading, stopLoading } = useLoading()
export const useChatHistoryLoading = (): UseChatHistoryLoading => {
  // this is the same as useLoading(), this composable needs to use his own loading ref
  return {
    startLoading,
    stopLoading,
    loading: readonly(loading),
  }
}
